<template>
    <div class="in-view-lazy-component">
        <in-view>
            <lazy-component v-bind="$props" @response="onResponse" @error="onError">
                <template #loading="loadingSlot">
                    <!-- @slot Loading content -->
                    <slot v-bind="loadingSlot" name="loading"></slot>
                </template>
                <template #error="errorSlot">
                    <!-- @slot Error content -->
                    <slot v-bind="errorSlot" name="error"></slot>
                </template>
                <template #default="defaultSlot">
                    <!-- @slot Default content when having `response` and `component` objects available -->
                    <slot v-bind="defaultSlot"></slot>
                </template>
            </lazy-component>
        </in-view>
    </div>
</template>

<script>
import InView from '@v4/common/components/atoms/InView';
import LazyComponent from '@v4/common/components/atoms/LazyComponent';

/**
 * Combines together `InView` and `LazyComponent` components
 */
export default {
    name: 'InViewLazyComponent',
    components: {
        InView,
        LazyComponent,
    },
    props: {
        /**
         * Component name which should be located in `common/components/dynamic` folder
         */
        name: {
            type: String,
            default: '',
        },
        /**
         * Props passed to `FetchData` component
         */
        fetchData: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        onResponse(...args) {
            /**
             * Fired when getting success response from `FetchData` component
             *
             * @event response
             * @type {object}
             * @property {object} payload - Payload data
             */
            this.$emit('response', ...args);
        },
        onError(...args) {
            /**
             * Fired when getting error response from `FetchData` component
             *
             * @event response
             * @type {object}
             * @property {object} payload - Payload data
             */
            this.$emit('error', ...args);
        },
    },
};
</script>
